import * as React from "react";

import {cn} from "../lib/utils";

function Input({className, type, ...props}: React.ComponentProps<"input">) {
  return <input type={type} data-slot="input" className={cn("h-11 border-input bg-input/10 text-md shadow-xs selection:bg-primary selection:text-primary-foreground file:text-foreground placeholder:text-muted-foreground/50 flex w-full min-w-0 rounded-md border px-3 py-1 outline-none transition-[color,box-shadow] file:inline-flex file:h-7 file:border-0 file:bg-transparent file:text-sm file:font-medium disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50 md:text-sm", "focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px]", "aria-invalid:border-destructive aria-invalid:ring-destructive/20", className)} {...props} />;
}

export {Input};
